import { render } from "./TheListAbout.vue?vue&type=template&id=1ecdc9d2&ts=true"
import script from "./TheListAbout.vue?vue&type=script&lang=ts"
export * from "./TheListAbout.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__